import { useNavigate } from "react-router-dom";

export const Forbidden = () => {
    const navigate = useNavigate();

    return (
        <div className="flex min-h-full items-center justify-center">
            <div className="text-center">
                <div className="text-red-500">You do not have access to this service.</div>
                <div className="text-red-500">Log out to try again, or log in to another account.</div>
                <p>
                    <button onClick={() => navigate("/logout")} className="transition ease-in-out hover:shadow-sm bg-slate-200 hover:bg-sky-100 gap-2 py-2 px-4 m-4 justify-center rounded-md">
                        Log out
                    </button>
                </p>
            </div>
        </div>
    )
};